import gql from 'graphql-tag';

// The project whose theme the "Katalog in deiner CI" view uses (spec 2026-10-03 Lesbarkeit §7):
// the project itself, or in a folder its first project by name. Its group settings decide the sidebar list.
export default gql`
query getKatalogCiBuehne($where: projects_bool_exp!) {
  projects(where: $where, order_by: {name: asc}, limit: 1) {
    project_id
    name
    editor_version
    item_path
    group {
      group_id
      slug
      settings
    }
    theme {
      name
    }
    template_collection {
      name
    }
    child_pages(limit: 1) {
      template {
        name
      }
    }
  }
}
`;
